import { Component } from '@angular/core';

@Component({
  template: `
  <div class="container">
  <div class="card" role="alert">
  <div class="card-block p-2">
    <h1 class="card-title">HTTP error 401.1 - Unauthorized: </h1>
    <p class="card-text"> Access is denied due to invalid credentials. 
    Please follow the link received thru your email, to access or Call Customer care</p>
    </div>
    </div> </div>
  `
})
export class UnauthorizeComponent {
  constructor() {

  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/app/common/component/401-unauthorize.component.ts